module.exports = __webpack_public_path__ + "img/paci_en_5.bdb67c4c.png";